module.exports = __webpack_public_path__ + "why6.webp?14a24e6a3862d41d18950f3c18ab663f";